export function x(p) {
  return p[0];
}

export function y(p) {
  return p[1];
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-shape/src/point.js
// module id = ../../../../d3-shape/src/point.js
// module chunks = 4